import { Button, Form, message, Radio, Select } from 'antd'
import React, { useState } from 'react'
import { useEffect } from 'react';
import { postFrom } from '../../../axios';
import { API_merchant_findAll } from '../../../axios/config';
import DatePickerYearMonth from '../../../components/DatePicker/YearMonth'
import DatePickerMoment from '../../../components/DatePicker'
import moment from 'moment';

const AccountingRecordReportSearch = (props) => {
    const [merchantList, setMerchantList] = useState([]);
    useEffect(() => {
        postMerchantList()
    }, [])
    const handleDateTypeChange = (e) => {
        const dateType = e.target.value
        const clear = {
            year: undefined,
            month: undefined,
            startDate: undefined,
            endDate: undefined
        }
        if (dateType === 2) {
            clear.month = moment().subtract(1, 'month').format('YYYY-MM')  //默认查上月
        }
        props.onChange({
            ...props.value, 
            ...clear,
            dateType
        })
    }

    const handleYearChange = (e) => {
        props.onChange({...props.value, year: e.format('YYYY')})
    }
    const handleMonthChange = (e) => {
        props.onChange({...props.value, month: e.format('YYYY-MM')})
    }

    const handleDateChange = (e, type) => {
        props.onChange({...props.value, [type]: e})
    }

    const handleMerchantChange = (e) => {
        console.log(e)
        props.onChange({...props.value, merchantIds: e})
    }

    const handleSearch = () => {
        if (props.value.startDate && props.value.endDate && moment(props.value.startDate).add(1, 'month').isBefore(props.value.endDate)) {
            message.warning('按天查询最多支持一个月')
            return
        }
        props.onSearch()
    }

    const type = [
        { title: '年', value: 1 },
        { title: '月', value: 2 },
        { title: '日', value: 3 },
    ]

    const postMerchantList = () => {
        postFrom({
            url: API_merchant_findAll,
            data: {},
        })
            .then((res) => {
                setMerchantList(res)
            })
            .catch((err) => {
                message.error(err.message || "获取商户列表失败");
            });
    }
    const renderData = (type) => {
        if (type === 1) {
            return (
                <Form.Item>
                    <DatePickerYearMonth value={props.value.year } format="YYYY" onChange={handleYearChange} mode="year" placeholder="选择年份" />
                </Form.Item>
            )
        }
        
        if (type === 2) {
            return (
                <Form.Item>
                    <DatePickerYearMonth value={props.value.month } format="YYYY-MM" onChange={handleMonthChange} mode="month" placeholder="选择月份" />
                </Form.Item>
            )
        }
        if (type === 3) {
            return (
                <React.Fragment>
                    <Form.Item>
                        <DatePickerMoment  value={props.value.startDate} onChange={(e, datastring) => handleDateChange(datastring, 'startDate')} placeholder="开始日期" />
                    </Form.Item>
                    <Form.Item>
                        <DatePickerMoment  value={props.value.endDate} onChange={(e, datastring) => handleDateChange(datastring, 'endDate')} placeholder="截止日期" />
                    </Form.Item>
                </React.Fragment>
            )
        }
    }

    return (
        <div style={{display: 'flex', justifyContent: 'space-between' }}>
            <Form layout="inline" >
                <Form.Item>
                    <Radio.Group value={props.value.dateType} onChange={handleDateTypeChange} buttonStyle="solid">
                        {type.map(e => <Radio.Button value={e.value}>{e.title}</Radio.Button> )}
                    </Radio.Group>
                </Form.Item>
                { renderData(props.value.dateType) }
            
                
                
                <Form.Item>
                    <Select 
                        value={props.value.merchantIds} 
                        mode="multiple" 
                        style={{width: 360}} 
                        placeholder="选择商户"
                        onChange={handleMerchantChange}
                    >
                        {merchantList.map(e => <Select.Option value={e.id} key={e.id}>{e.shortName}</Select.Option>)}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={handleSearch}>查询</Button>
                </Form.Item>
            </Form>
            <div style={{paddingTop:4}}>
                {props.children}
            </div>
        </div>
    )
}

export default AccountingRecordReportSearch


// WEBPACK FOOTER //
// ./src/page/AccountingRecordReport/components/SearchView.jsx